import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appRegexFilter]',
})
export class RegexFilterDirective {
  @Input('appRegexFilter') regexPattern: string = '';

  private get regex(): RegExp {
    return new RegExp(this.regexPattern, 'g');
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const original = input.value;
    const selectionStart = input.selectionStart || 0;

    const filtered = (original.match(this.regex) || []).join('');

    if (original !== filtered) {
      // Calculate how many invalid characters were removed *before* the cursor
      const beforeCursor = original.slice(0, selectionStart);
      const filteredBeforeCursor = (beforeCursor.match(this.regex) || []).join('');
      const newCursorPos = filteredBeforeCursor.length;

      // Apply the filtered value
      input.value = filtered;

      // Restore cursor position
      input.setSelectionRange(newCursorPos, newCursorPos);

      // Trigger model update
      input.dispatchEvent(new Event('input'));
    }
  }
}
